import { connect } from 'react-redux';
import OrganisationInfo from './../../../../../shared/components/OrganisationInfo';
import { selectors as customerSelectors } from './../../../../../../shared/ducks/customer.duck';
import { createSelector } from 'reselect';
import getFlags from 'state/selectors/getFlags';

const customerData = createSelector(customerSelectors.data, (data) => data);

const OrganisationCustomerView = connect((state) => ({
  customer: customerData(state),
  isSrmAdmin: getFlags(state).includes('SRM_ADMIN'),
}))(OrganisationInfo);

export default OrganisationCustomerView;
